import { jsx, Fragment } from 'react/jsx-runtime';
import React__default, { useState, useRef, useEffect, useMemo } from 'react';

const RenderIfVisible = ({ initialVisible = false, defaultHeight = 300, visibleOffset = 1e3, stayRendered = false, root = null, rootElement = "div", rootElementClass = "", placeholderElement = "div", placeholderElementClass = "", children }) => {
  const [isVisible, setIsVisible] = useState(initialVisible);
  const wasVisible = useRef(initialVisible);
  const placeholderHeight = useRef(defaultHeight);
  const intersectionRef = useRef(null);
  useEffect(() => {
    if (intersectionRef.current) {
      const localRef = intersectionRef.current;
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) {
          placeholderHeight.current = localRef.offsetHeight;
        }
        if (typeof window !== "undefined" && window.requestIdleCallback) {
          window.requestIdleCallback(() => setIsVisible(entries[0].isIntersecting), {
            timeout: 600
          });
        } else {
          setIsVisible(entries[0].isIntersecting);
        }
      }, {
        root,
        rootMargin: `${visibleOffset}px 0px ${visibleOffset}px 0px`
      });
      observer.observe(localRef);
      return () => {
        if (localRef) {
          observer.unobserve(localRef);
        }
      };
    }
    return () => {
    };
  }, [
    root,
    visibleOffset
  ]);
  useEffect(() => {
    if (isVisible) {
      wasVisible.current = true;
    }
  }, [
    isVisible
  ]);
  const placeholderStyle = {
    height: placeholderHeight.current
  };
  const rootClasses = useMemo(() => `renderIfVisible ${rootElementClass}`, [
    rootElementClass
  ]);
  const placeholderClasses = useMemo(() => `renderIfVisible-placeholder ${placeholderElementClass}`, [
    placeholderElementClass
  ]);
  return /* @__PURE__ */ React__default.createElement(rootElement, {
    ref: intersectionRef,
    className: rootClasses
  }, isVisible || stayRendered && wasVisible.current ? /* @__PURE__ */ jsx(Fragment, {
    children
  }) : /* @__PURE__ */ React__default.createElement(placeholderElement, {
    className: placeholderClasses,
    style: placeholderStyle
  }));
};

export { RenderIfVisible };
//# sourceMappingURL=RenderIfVisible.js.map
